import styled from "styled-components";
import Variables from "../../assets/styleVariables";

const toastrWidth = "377px";
const successBgColor = `${Variables.colors.black_800}`;
const infoBgColor = `${Variables.colors.black_800}`;
const warningBgColor = `${Variables.colors.black_800}`;
const errorBgColor = `${Variables.colors.black_800}`;
const defaultSpace = "10px";

export const ToastContainer = styled.div`
  body.toastr-confirm-active {
    overflow: hidden;
  }
  
  .redux-toastr {
    *,
    *:before,
    *:after {
      box-sizing: border-box;
    }

    .top-left,
    .top-right,
    .top-center,
    .bottom-left,
    .bottom-right,
    .bottom-center {
      min-width: ${toastrWidth};
      position: fixed;
      z-index: 99999999;
      padding: 0 ${defaultSpace};
    }

    .top-left,
    .top-right,
    .top-center {
      top: 0;
    }

    .top-right,
    .bottom-right {
      right: 0;
    }

    .bottom-left,
    .bottom-right,
    .bottom-center {
      bottom: 60px;
    }

    .top-left,
    .bottom-left {
      left: 0;
    }

    .top-center,
    .bottom-center {
      left: 50%;
      margin-left: -${toastrWidth / 2};
    }

    @media (max-width: 320px) {
      .top-left,
      .top-right,
      .top-center,
      .bottom-left,
      .bottom-right,
      .bottom-center {
        width: ${toastrWidth - 30};
      }

      .top-center,
      .bottom-center {
        margin-left: -(${(toastrWidth - 30) / 2});
      }
    }

    .toastr {
      direction: rtl !important;
      text-align: right;
      background-color: #fcfcfc;
      width: 100%;
      min-height: 48px;
      overflow: hidden;
      margin: ${defaultSpace} 0;
      border-radius: 4px;
      position: relative;
      z-index: 2;
      color: ${Variables.colors.complementary_400};
      opacity: 0.94;
      -webkit-box-shadow: 0 3px 12px 0 #cccccc;
      -moz-box-shadow: 0 3px 12px 0 #cccccc;
      box-shadow: 0 3px 12px 0 #cccccc;

      &:hover:not(.rrt-message) {
        -webkit-box-shadow: 0 3px 12px 0 #cccccc;
        -moz-box-shadow: 0 3px 12px 0 #cccccc;
        box-shadow: 0 3px 12px 0 #cccccc;
        opacity: 1;
      }

      .toastr-status {
        width: 100%;
        height: 5px;

        &.success {
          background-color: ${successBgColor};
        }

        &.warning {
          background-color: ${warningBgColor};
        }

        &.info {
          background-color: ${infoBgColor};
        }

        &.error {
          background-color: ${errorBgColor};
        }
      }

      .rrt-left-container,
      .rrt-right-container {
        float: left;
        text-align: center;
        overflow: hidden;
      }

      .rrt-left-container {
        width: 80px;
        top: 0;
        right: 0;
        position: absolute;
        bottom: 0;

        .rrt-holder {
          width: 70px;
          height: 70px;
          position: absolute;
          top: 50%;
          margin-top: -31px;
          left: 5px;
          line-height: 60px;
        }

        .toastr-icon {
          fill: ${Variables.colors.complementary_500};
          vertical-align: middle;
          margin-top: 5px;
          width: 20px !important;
          height: 20px !important;
        }
      }

      .rrt-middle-container {
        width: 65%;
        margin-right: 80px !important;
        position: relative;
        float: right !important;
        font-family: Number, sans-serif;
        line-height: 1.6;
        font-size: 15px;
        text-align: right;
        padding: 10px 5px;

        .rrt-title {
          font-size: 1.1em;
          font-weight: bold;
          margin-bottom: 5px;
        }
      }

      .rrt-right-container {
        width: 10%;
      }

      .close-toastr {
        width: 10%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 8px;
        right: 86%;
        background-color: transparent;
        font-size: 22px;
        border: none;
        outline: none;
        opacity: 0.5;
        cursor: pointer;
        font-family: Number, sans-serif;
        color: ${Variables.colors.complementary};

        &:hover {
          opacity: 1;
        }

        &:focus {
          outline: none;
        }

        span {
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          left: 0;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 40px;
          height: 40px;
          border-radius: 50%;
          padding-top: 3px;
          font-size: 14px;
          &:hover {
            background-color: ${Variables.colors.complementary_800};
          }
        }
      }

      &.rrt-info,
      &.rrt-success,
      &.rrt-warning,
      &.rrt-error {
        color: white;
      }

      &.rrt-info {
        background-color: ${infoBgColor};

        .rrt-progressbar {
          background-color: darken(${infoBgColor}, 15%);
        }
      }

      &.rrt-success {
        background-color: ${successBgColor};

        .rrt-progressbar {
          background-color: darken(${successBgColor}, 15%);
        }
      }

      &.rrt-warning {
        background-color: ${warningBgColor};

        .rrt-progressbar {
          background-color: darken(${warningBgColor}, 15%);
        }
      }

      &.rrt-error {
        background-color: ${errorBgColor};

        .rrt-progressbar {
          background-color: darken(${errorBgColor}, 15%);
        }
      }

      &.rrt-light {
        .rrt-progressbar {
          background-color: #ccc;
        }
        .toastr-icon {
          fill: ${Variables.colors.complementary_400} !important;
        }
      }

      &.rrt-message {
        opacity: 1;
        border: 1px solid #dbdbdb;

        .rrt-title {
          width: 90%;
          height: 50px;
          text-align: center;
          overflow: hidden;
          font-size: 1.2em;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          line-height: 50px;
          padding: 0 20px;
        }

        .rrt-text {
          width: 100%;
          max-height: 400px;
          overflow: hidden;
          overflow-y: auto;
          border-top: 1px solid #f1f1f1;
          border-bottom: 1px solid #f1f1f1;
          background-color: white;
          padding: 15px;
          font-size: 1.1em;
          margin-bottom: 20px;

          img {
            display: block;
            margin: 10px auto;
            max-width: 100%;
          }
        }

        .close-toastr {
          color: #fff;
          border: 3px solid #fff;
          height: 50px;
        }
      }

      .rrt-progress-container {
        height: 5px;
        margin: 0 -20px -20px -60px;
        position: absolute;
        bottom: 20px;
        width: 100%;

        .rrt-progressbar {
          -webkit-border-radius: 0 0 0 4px;
          -moz-border-radius: 0 0 0 4px;
          border-radius: 0 0 0 4px;
          height: 100%;
        }
      }
    }

    .toastr-attention {
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.4);
      z-index: 1;
    }
  }
`;
